import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { storageKey: String }

  connect() {
    if (this.dismissed()) return

    this.element.classList.remove("hidden")
    this.capture("subscription_project_promotion_shown")
  }

  dismiss() {
    if (!this.storeDismissal()) return

    this.element.remove()
    this.capture("subscription_project_promotion_dismissed")
  }

  dismissed() {
    try {
      return localStorage.getItem(this.storageKeyValue) !== null
    } catch (_error) {
      return true
    }
  }

  storeDismissal() {
    try {
      localStorage.setItem(this.storageKeyValue, "true")
      return true
    } catch (_error) {
      return false
    }
  }

  capture(eventName) {
    window.posthog?.capture(eventName, {
      source: "project_banner",
      promoted_tier: "max"
    })
  }
}
